/**
 * sl-kqzl.5: Permission Overview Coachmark
 *
 * Three-step session shown once after the user completes their first
 * automation setup (workflow selected + config saved). Teaches who runs the
 * automation, what permissions are required, and surfaces the plan-specific
 * upgrade path.
 *
 * Persistence uses the shared TutorialPersistence service under sessionId
 * `automation:permissionOverview` — no parallel localStorage key (DRY with
 * the existing tutorial system).
 */
import type { useI18n } from '@affine/i18n';

import type { TutorialSession } from '../../types';

type I18n = ReturnType<typeof useI18n>;

export const PERMISSION_OVERVIEW_SESSION_ID = 'automation:permissionOverview';

export function createPermissionOverviewSession(t: I18n): TutorialSession {
  return {
    id: PERMISSION_OVERVIEW_SESSION_ID,
    showDismissPermanentlyCheckbox: true,
    context: {
      targetAudience: 'technical',
      category: 'automation',
      tab: 'overview',
    },
    steps: [
      {
        targetSelector: '[data-coachmark-target="trigger-type-menu"]',
        title: t['com.streamlain.automation.coachmark.step1.title'](),
        content: t['com.streamlain.automation.coachmark.step1.body'](),
        animation: 'pulse',
        position: 'right',
      },
      {
        targetSelector: '[data-coachmark-target="trigger-enable-toggle"]',
        title: t['com.streamlain.automation.coachmark.step2.title'](),
        content: t['com.streamlain.automation.coachmark.step2.body'](),
        animation: 'highlight',
        position: 'right',
      },
      {
        title: t['com.streamlain.automation.coachmark.step3.title'](),
        content: t['com.streamlain.automation.coachmark.step3.body'](),
        animation: 'none',
      },
    ],
  };
}
